"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_SPECIFIC_APP_CONFIG = exports.GET_APP_CONFIG = exports.CHECK_FOR_APP_UPDATE = void 0;
const GET_APP_CONFIG = exports.GET_APP_CONFIG = 'AppConfig';
const GET_SPECIFIC_APP_CONFIG = exports.GET_SPECIFIC_APP_CONFIG = 'SpecificAppConfig';
const CHECK_FOR_APP_UPDATE = exports.CHECK_FOR_APP_UPDATE = 'CheckForAppUpdate';